import { cx, useSwipe } from "@jugl-web/utils";
import { FC } from "react";
import { PlainButton } from "../../primitives/PlainButton";
import { ReactComponent as CloseIcon } from "./icons/close.svg";
import { SwipeableHeaderProps } from "./types";

export const SwipeableHeader: FC<SwipeableHeaderProps> = ({
  title,
  startSlot,
  hasHandle = true,
  hasCloseButton = true,
  customEndSlot,
  isDetached,
  showOnlyEndSlot,
  className,
  onClose,
  onSwipeUp,
}) => {
  const { touchProps } = useSwipe({
    onSwipeDown: onClose,
    onSwipeUp,
  });

  return (
    <header
      className={cx(
        "relative flex items-center justify-between px-4 pt-[30px] pb-5",
        className
      )}
    >
      {isDetached && (
        <div className="absolute inset-x-4 bottom-0 h-px bg-[#F6F6F6]" />
      )}
      {hasHandle && (
        <div className="absolute inset-x-0 top-0 h-10" {...touchProps}>
          <div className="absolute top-4 left-1/2 h-1 w-14 -translate-x-1/2 rounded-sm bg-[#F2F2F2]" />
        </div>
      )}
      {!showOnlyEndSlot && (
        <div className="flex items-center gap-4 overflow-hidden">
          {startSlot}
          <span className="truncate font-secondary text-base font-medium text-[#383838]">
            {title}
          </span>
        </div>
      )}
      {customEndSlot ||
        (hasCloseButton && (
          <PlainButton onClick={onClose} className="relative">
            <CloseIcon />
          </PlainButton>
        ))}
    </header>
  );
};
